var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 15,
    viewBox: "0 0 7 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_397_3995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54153 8.43697L6.91092 5.72357H4.64285V3.95987C4.64285 3.21792 4.96052 2.49294 5.97635 2.49294H7.00696V0.182307C6.39603 0.0696757 5.77871 0.00874256 5.15999 0C3.29086 0 2.07187 1.30158 2.07187 3.65461V5.72357H-0.0078125V8.43697H2.07187V15H4.64285V8.43697H6.54153Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_397_3995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 15,
    fill: "#333333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.027814527eaaf977a1adab760cb497bf.svg";
export { ForwardRef as ReactComponent };